import { useNavigate } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function LatestUpdates() {
  const navigate = useNavigate();
  const sortedAnime = [...animeList].sort((a, b) => {
    const dateA = a.episodesList[0]?.publishDate || '';
    const dateB = b.episodesList[0]?.publishDate || '';
    return dateB.localeCompare(dateA);
  });

  const handleClick = (id: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/article/${id}`);
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时追踪每一部番剧的最新话</p>
          </div>
          <button
            onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate('/category/all'); }}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="space-y-3">
          {sortedAnime.map((anime) => {
            const latestEp = anime.episodesList[0];
            return (
              <div
                key={anime.id}
                onClick={() => handleClick(anime.id)}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
              >
                <div className="relative w-16 h-10 md:w-20 md:h-12 rounded-md overflow-hidden bg-background-300 shrink-0">
                  <img
                    src={latestEp?.thumbnail}
                    alt={`${anime.title} 第${latestEp?.number}集`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {anime.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    更新至第{latestEp?.number}集 · {latestEp?.publishDate} · {anime.updateDay}更新
                  </p>
                </div>
                <div className="hidden sm:flex items-center gap-3 shrink-0">
                  <span className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">
                    {anime.rating}分
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {anime.category}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}